import { BaseDto } from "@models/base/baseDto.model"

export class UpdateMenuRequest extends BaseDto {
  public icon?:string
  public path?:string
  public idMenuPadre?:number
  public nivel?:number
  public orden?: number
}
